import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=beaa819a&scoped=true&"
import script from "./Column.vue?vue&type=script&lang=js&"
export * from "./Column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaa819a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beaa819a')) {
      api.createRecord('beaa819a', component.options)
    } else {
      api.reload('beaa819a', component.options)
    }
    module.hot.accept("./Column.vue?vue&type=template&id=beaa819a&scoped=true&", function () {
      api.rerender('beaa819a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/traceability/Column.vue"
export default component.exports